import React, { Component } from 'react'
import { type FormikProps } from 'formik'
import Dropdown from 'legacy/components/Dropdown'
import withDepartmentAisles from 'legacy/common/withDepartmentAisles'
import { type NewProductFormValues } from 'legacy/routes/catalog/types/product.types'
import FormSection from './FormSection'
import FormField from './FormField'

interface DepartmentAndAisleProps {
  onDepartmentSelected: (id: number) => void
  departments: { id: number; name: string }[] | null
  aisles: { id: number; name: string }[] | null
  aislesLoading: boolean
  departmentsLoading: boolean
  value: number | null
}

interface Props extends FormikProps<NewProductFormValues>, DepartmentAndAisleProps {}

class ProductAisle extends Component<Props> {
  handleDepartmentChange = (departmentId: number) => {
    this.props.setFieldValue('departmentId', departmentId)
    this.props.onDepartmentSelected(departmentId)
  }

  handleAisleChange = (aisleId: number) => {
    this.props.setFieldValue('aisleId', aisleId)
  }

  optionify = (list: { id: number; name: string }[] | null) =>
    list
      ? list.map(({ id, name }) => ({
          label: name,
          value: id,
        }))
      : []

  render() {
    const { departments, aisles, departmentsLoading, aislesLoading, values, errors, touched } =
      this.props

    return (
      <FormSection titleId="catalog.product.aisle">
        <div style={{ display: 'flex' }}>
          <FormField label="Department">
            <Dropdown
              margin="0"
              defaultText="Select Department"
              isBusy={departmentsLoading}
              options={this.optionify(departments)}
              value={values.departmentId}
              onChange={this.handleDepartmentChange}
              handlesError
              isError={touched.departmentId && !!errors.departmentId}
              errorText={errors.departmentId}
            />
          </FormField>
          <div style={{ width: '20px' }} />
          <FormField label="Aisle">
            <Dropdown
              margin="0"
              defaultText="Select Aisle"
              isBusy={aislesLoading}
              options={this.optionify(aisles)}
              value={values.aisleId}
              onChange={this.handleAisleChange}
              handlesError
              isError={touched.aisleId && !!errors.aisleId}
              errorText={errors.aisleId}
            />
          </FormField>
        </div>
      </FormSection>
    )
  }
}

export default withDepartmentAisles(ProductAisle)
